import { css } from '@emotion/react';
import { media, tokens, applyFont, shadow } from '@domain-group/fe-brary';

export const callToActions = css`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ctaLink = css`
  text-decoration: none;
  ${applyFont(tokens.typography.body)}
  background: ${tokens.colors.neutral.surface.default};
  color: ${tokens.colors.neutral.heavy.default};
  box-sizing: border-box;
  border-radius: ${tokens.borderRadius.outer};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${tokens.spacing.xs};
  padding: ${tokens.spacing.xs} ${tokens.spacing.s};
  width: 100%;
  border: 1px solid ${tokens.colors.neutral.trim.default};
  box-shadow: none;
  transition:
    box-shadow 150ms ease,
    color 150ms ease;

  ${media('>=tablet')} {
    gap: ${tokens.spacing.s};
    padding: ${tokens.spacing.xs} ${tokens.spacing.m};
  }

  &:hover {
    box-shadow: ${shadow(tokens.shadows.elevation4)};

    p {
      color: ${tokens.colors.interactive.base.hover};
    }
  }

  &:active {
    box-shadow: ${shadow(tokens.shadows.elevation1)};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.interactive.base.default};

    p {
      color: ${tokens.colors.interactive.base.default};
    }
  }
`;

export const ctaIcon = css`
  flex-shrink: 0;
  width: 80px;
  height: 80px;

  img,
  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  ${media('>=tablet')} {
    width: 120px;
    height: 120px;
  }
`;

export const text = css`
  ${applyFont(tokens.typography.body)}
  color: ${tokens.colors.neutral.heavy.default};
  transition: color 150ms ease;
  margin: 0;
`;
